import { useEffect } from "react";

export const useClickOutside = (ref, callback) => {
  const handleClickOutside = (event) => {
    if (ref && ref?.current && !ref?.current?.contains(event.target)) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, callback]);
};
